import { render, staticRenderFns } from "./DateFilter.vue?vue&type=template&id=535568c8"
import script from "./DateFilter.vue?vue&type=script&lang=ts"
export * from "./DateFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports